module.exports = __webpack_public_path__ + "img/lala_scroll04.bf87f6fa.webp";